<template>
    <nav
        role="navigation"
        aria-label="Mobile Nav"
        id="mobilenav"
        class="sticky-top theme-green"
    >
        <div class="mobile-section-nav d-lg-none">
            <div class="ct">
                <!-- section nav area -->
                <nav role="navigation" aria-label="Section Nav">
                    <div class="dropdown show">
                        <button
                            class="btn dropdown-toggle rounded-0 toggleMask"
                            type="button"
                            id="sectionNavButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="true"
                            v-on:click="dropDownToggle"
                        >
                            <span class="sr-only">Section Navigation</span>
                            <span class="mobile-title">BRFSS WEAT</span>
                            <span
                                id="svg-down"
                                :class="`fi cdc-icon-arrow-down ${isVisibleClass}`"
                                aria-hidden="true"
                            ></span>
                        </button>
                        <!-- style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-5px, 44px, 0px);" -->
                        <div
                            :class="`dropdown-menu w-100 rounded-0 m-0 ${isVisibleClass}`"
                            id="mobileNav-dropdown"
                            aria-labelledby="sectionNavButton"
                            x-placement="bottom-start"
                            ref="dropDownMenu"
                        >
                            <nav
                                role="navigation"
                                aria-label="Left Nav"
                                id="leftnav"
                            >
                                <div class="list-group indicator-plus">
                                    <ul>
                                        <li class="list-group-item nav-lvl1">
                                            <div class="h4">Actions</div>
                                            <brfss-router-link
                                                v-for="(item, i) in actionsMenu"
                                                v-bind:key="'action_' + i"
                                                :item="item"
                                                :isActive="
                                                    item.name === menuItem
                                                "
                                            ></brfss-router-link>

                                            <!-- <a
                                                href="#"
                                                @click="
                                                    redirectUser(
                                                        $event,
                                                        item.url
                                                    )
                                                "
                                                :class="
                                                    item.name === menuItem
                                                        ? 'active'
                                                        : ''
                                                "
                                            >{{ item.title }}</a>-->
                                        </li>
                                        <li
                                            class="list-group-item nav-lvl1"
                                            v-if="reportsMenu.length > 0"
                                        >
                                            <div class="h4">Reports</div>
                                            <brfss-router-link
                                                v-for="(item, i) in reportsMenu"
                                                v-bind:key="'reports_' + i"
                                                :item="item"
                                                :isActive="
                                                    item.name === menuItem
                                                "
                                            ></brfss-router-link>
                                        </li>
                                        <li class="list-group-item nav-lvl1">
                                            <div class="h4">User Guide</div>
                                            <brfss-router-link
                                                v-for="(
                                                    item, i
                                                ) in userGuideMenu"
                                                v-bind:key="'userGuide_' + i"
                                                :item="item"
                                                :isActive="
                                                    item.name === menuItem
                                                "
                                            ></brfss-router-link>
                                        </li>
                                        <li>
                                            <div class="h4">
                                                Related Information
                                            </div>
                                            <a
                                                href="https://www.cdc.gov/brfss/state_info/coordinators.htm"
                                                target="_blank"
                                                >State Coordinators</a
                                            >
                                            <a
                                                href="https://www.cdc.gov/brfss/"
                                                target="_blank"
                                                >BRFSS Home</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <a
                                    href="#"
                                    @click="redirectUser($event, '/analysis')"
                                    class="
                                        list-group-item
                                        mobile-section-nav-foot
                                    "
                                >
                                    <span class="fi cdc-icon-home x24"></span>
                                    <span class="mobile-foot-title"
                                        >BRFSS WEAT</span
                                    >
                                </a>
                            </nav>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    </nav>
</template>
<script>
/* eslint no-tabs: 'off', one-var: 'off' */
import { mapGetters, mapState } from 'vuex';
import store from '@/store';
//import navigation from "@/components/layout/navigation";
import navMenuItems from '@/scripts/nav/menuItems';
import brfssRouterLink from '@/components/sub/brfssRouterLink';

export default {
    props: [],
    computed: {
        ...mapState({
            menuGroup: (state) => state.display.menuGroup,
            menuItem: (state) => state.display.menuItem,
            showMobileMenu: (state) => state.display.showMobileMenu
        })
    },
    components: {
        //navigation: navigation,
        'brfss-router-link': brfssRouterLink
    },
    created: function () {},
    mounted: () => {
        // $('#navmenu2').css({ left: 0, display: 'none' });
        // $(document).on('click', 'a.page-link', function () {
        //   $('#navmenu2').css({ left: 0, display: 'block' });
        //   $('#navmenu2').animate({
        //     left: '100%'
        //   }, 500, function () {
        //     $('#navmenu2').css({ left: 0, display: 'none' });
        // });
        // $('#vp1-menu-button').on('click', function (e) {
        //   $(this).blur(); // remove focus rectangle
        //   var t = $(this),
        //     navmenu2 = $('#navmenu2'),
        //     ln = $('nav#left:first');
        //   //var topPosition = t.prop('tagName').toLowerCase() === 'li' ?
        //   //  t.offset().top + t.outerHeight() :
        //   //  t.parent().offset().top + t.parent().outerHeight();
        //   var leftPosition = t.prop('tagName').toLowerCase() === 'li' ?
        //     t.offset().left - 120 + t.outerWidth() :
        //     t.parent().offset().left - 120 + t.parent().outerWidth();
        //   $('#navmenu2').css({ position: 'absolute', left: leftPosition, height: 'auto' })
        //     .toggle(100, function () { $('#navmenu2 a.the-back-btn').focus(); });
        //   //}
        // });
    },
    data: function () {
        return {
            store: store,
            actionsMenu: navMenuItems.menuItems.rootMenus.actions || [],
            reportsMenu: navMenuItems.menuItems.rootMenus.reports || [],
            userGuideMenu: navMenuItems.menuItems.rootMenus.userGuide || [],
            isVisible: false,
            isVisibleClass: ''
        };
    },
    methods: { redirectUser, dropDownToggle }
};

function menuIsVisible(vm) {
    return vm.$refs.dropDownMenu.classList.contains('show');
}
function dropDownToggle(e) {
    let vm = this;
    vm.isVisible = !menuIsVisible(vm);
    vm.isVisibleClass = vm.isVisible ? ' show' : '';
}

function redirectUser(e, url) {
    let vm = this;
    if (e) e.preventDefault();
    store.dispatch('display/clearMessages');
    this.$router.push(url);
    return false;
}
</script>

<style scoped>
.cdc-icon-home:before {
    content: '\f221';
}
.x24::before {
    font-size: 24px;
    text-align: center;
}

.x24::before {
    font-size: 24px;
    text-align: center;
}

.mobile-section-nav-foot {
    color: #fff !important;
    line-height: 25px;
    padding: 12.75px 21.25px;
    display: block;
}

.mobile-section-nav nav .dropdown ul a.nav-minus:link,
.mobile-section-nav nav .dropdown ul a.nav-plus:link {
    display: none;
}

.mobile-section-nav nav .dropdown-toggle #svg-down {
    width: 40px;
    height: 40px;
    position: absolute;
    border-radius: 20px;
    right: 30px;
    bottom: -12px;
    z-index: 1002;
    transition: transform 0.4s ease;
    margin-bottom: -8px;
    border: 2px solid #fff;
    fill: #fff;
}

@media (min-width: 1200px) {
    .mobile-section-nav {
        display: none;
        /* inheritbutton, input, optgroup, select, textarea */
        /* Arialbutton; */
        /*
        body
    -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"
    body
    sans-serifhtml; */
    }
}

.mobile-section-nav {
    /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
        'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
        'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; */
    /* font-family-sans-serif: -apple-system, BlinkMacSystemFont, 'Segoe UI',
        Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
        'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
        'Noto Color Emoji';
    font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,
        'Liberation Mono', 'Courier New', monospace; */
    font-family: 'Open Sans', apple-system, blinkmacsystemfont, 'Segoe UI',
        'Helvetica Neue', arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    box-sizing: border-box;
}

.mobile-section-nav nav .dropdown {
    z-index: 1070;
    /* font-family: 'Open Sans', apple-system, blinkmacsystemfont, 'Segoe UI', 'Helvetica Neue', arial, sans-serif; */
    /* font-family: "Open Sans",apple-system,blinkmacsystemfont,"Segoe UI","Helvetica Neue",arial,sans-serif; */
    /* font-family: 'Open Sans', apple-system, blinkmacsystemfont, 'Segoe UI',
        'Helvetica Neue', arial, sans-serif; */
}

.dropdown,
.dropleft,
.dropright,
.dropup {
    position: relative;
}

.mobile-section-nav nav .dropdown .btn {
    padding-top: 3px;
    padding-bottom: 3px;
    background-color: #f5f5f5;
    white-space: normal;
}

.mobile-section-nav nav .dropdown-toggle {
    border-bottom: 2px solid #f0f0f0;
    padding-left: 1rem;
    text-align: left;
    width: 100%;
    font-size: 23px;
}

[type='button']:not(:disabled),
[type='reset']:not(:disabled),
[type='submit']:not(:disabled),
button:not(:disabled) {
    cursor: pointer;
}

.btn {
    text-decoration: none;
}

.rounded-0 {
    border-radius: 0 !important;
}

.btn {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

[type='button'],
[type='reset'],
[type='submit'],
button {
    -webkit-appearance: button;
}

button,
select {
    text-transform: none;
}

button,
input {
    overflow: visible;
}

button,
input,
optgroup,
select,
textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}

/* .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
} */

@media (max-width: 991px) {
    .mobile-title {
        width: 84%;
        display: inline-block;
    }
}
.mobile-section-nav nav .dropdown-toggle #svg-down.fi {
    color: #fff;
}

.mobile-section-nav nav .dropdown-toggle #svg-down {
    width: 40px;
    height: 40px;
    position: absolute;
    border-radius: 20px;
    right: 30px;
    bottom: -12px;
    z-index: 1002;
    transition: transform 0.4s ease;
    margin-bottom: -8px;
    border: 2px solid #fff;
    fill: #fff;
}

.mobile-section-nav nav .dropdown-toggle #svg-down.fi::before {
    display: block;
    height: 40px;
    font-size: 36px;
    text-align: center;
}

.mobile-section-nav nav .dropdown-toggle::after {
    display: none;
}
.intranet .yamm .dropdown.show .dropdown-toggle::after {
    transform: rotate(180deg);
}

.mobile-section-nav #svg-down {
    background-color: #4b830d;
    font-size: 24px;
    /* line-height: 0.9em; */
    line-height: 20.7;
}

.btn [class*=' cdc-icon-'],
.btn [class^='cdc-icon-'] {
    line-height: 0.9em;
}

[class*=' cdc-icon-'],
[class^='cdc-icon-'] {
    position: relative;
    display: inline-block;
    vertical-align: middle;
}
.cdc-icon-arrow-down:before {
    content: '\f1f5';
    font-family: 'Open Sans', apple-system, blinkmacsystemfont, 'Segoe UI',
        'Helvetica Neue', arial, sans-serif;
}

.mobile-section-nav nav .dropdown-toggle #svg-down.fi::before {
    display: block;
    height: 40px;
    font-size: 36px;
    text-align: center;
}

[class*=' cdc-icon-']:before,
[class^='cdc-icon-']:before {
    font-family: cdciconfont;
    display: inline-block;
    line-height: 1;
    font-weight: 400;
    font-style: normal;
    speak: none;
    text-decoration: inherit;
    text-transform: none;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
/* <a href="/publichealthgateway/partnerships/capacity-building-assistance-OT18-1802.html" class="list-group-item-action">Strengthening Public Health Systems
                                    &amp; Services</a> */
.theme-green nav .mobile-section-nav li.active,
.theme-green nav ul.tp-nav-main li.active {
    background-color: #fff;
}

/*-----------------------------------------------------*/

.mobile-section-nav nav .dropdown .dropdown-menu {
    top: 43px !important;
    transform: none !important;
    padding-bottom: 0;
    z-index: 999 !important;
}

nav .mobile-section-nav .dropdown-menu,
nav ul.tp-nav-main .dropdown-menu {
    pointer-events: none;
}

.dropdown-menu.show {
    display: block;
}

.dropdown-menu[x-placement^='bottom'],
.dropdown-menu[x-placement^='left'],
.dropdown-menu[x-placement^='right'],
.dropdown-menu[x-placement^='top'] {
    right: auto;
    bottom: auto;
}

.m-0 {
    margin: 0 !important;
}

.w-100 {
    width: 100% !important;
}

.rounded-0 {
    border-radius: 0 !important;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
}
a:-webkit-any-link {
    color: #212529;
}

nav .mobile-section-nav .dropdown-menu,
nav ul.tp-nav-main .dropdown-menu {
    pointer-events: none;
}

/*-----------------------------------------------------*/
/* <div class="list-group indicator-plus"> */
/* .mobile-section-nav nav .dropdown .dropdown-menu .list-group {
    max-height: 400px;
    overflow-y: auto;
} */

.indicator-plus ul {
    margin-bottom: 0px;
}

.indicator-plus ul li {
    list-style-type: none;
}

.indicator-plus ul:last-child li a:last-child {
    border-bottom: none;
}
.list-group {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
}

/*-----------------------------------------------------*/
/* UL */
.mobile-section-nav nav .dropdown .list-group > ul {
    padding-left: 20px;
}

dl,
ol,
ul {
    margin-top: 0;
    margin-bottom: 1rem;
}
.theme-green .list-group-item.active {
    border-color: #4b830d;
}

/*-----------------------------------------------------*/
/* <li class="list-group-item nav-lvl3 active selected"> */
.theme-green nav .mobile-section-nav li.active,
.theme-green nav ul.tp-nav-main li.active {
    background-color: #fff;
}

nav .mobile-section-nav .list-group-item,
nav ul.tp-nav-main .list-group-item {
    border: inherit;
    background-color: inherit;
}

.list-group-item.active {
    z-index: 2;
    color: #fff;
}

.list-group-item:first-child {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}

nav .mobile-section-nav li,
nav ul.tp-nav-main li {
    margin: 0;
    padding: 0;
    position: relative;
}

/*-----------------------------------------------------*/
/* <li data-v-299ece46="" class="list-group-item nav-lvl3 active selected"> */

nav .mobile-section-nav li.active {
    background-color: #fff;
}

.list-group-item.active {
    border-color: #4b830d;
}
.list-group-item.active {
    z-index: 2;
    color: #fff;
}

/*-----------------------------------------------------*/
/* <a data-v-299ece46="" href="/publichealthgateway/partnerships/capacity-building-assistance-OT18-1802.html" class="list-group-item-action">Strengthening Public Health Systems
                                    &amp; Services</a> */
/*-----------------------------------*/
.theme-green nav .mobile-section-nav li.selected.active > a:first-child,
.theme-green nav ul.tp-nav-main li.selected.active > a:first-child {
    font-weight: 700;
}

.theme-green nav .mobile-section-nav li.selected > a:first-child {
    border-left-color: #4b830d;
}

.theme-green nav .mobile-section-nav li.selected.active > a,
.theme-green nav ul.tp-nav-main li.selected.active > a {
    background-color: #f5f5f5;
}

.theme-green nav .mobile-section-nav li.selected > a:first-child,
.theme-green nav ul.tp-nav-main li.selected > a:first-child {
    color: #4b830d;
}

nav .mobile-section-nav li a:active,
nav .mobile-section-nav li a:hover,
nav .mobile-section-nav li a:link,
nav .mobile-section-nav li a:visited,
nav .mobile-section-nav li ul li a:active,
nav .mobile-section-nav li ul li a:hover,
nav .mobile-section-nav li ul li a:link,
nav .mobile-section-nav li ul li a:visited {
    /* text-decoration: none;
    color: #333;
    position: relative; */
    display: block;
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    border-bottom: 1px dashed #e0e0e0;
    transition: border-color 0.5s, background-color 0.5s, color 0.5s;
}

nav .mobile-section-nav .dropdown-menu a,
nav ul.tp-nav-main .dropdown-menu a {
    pointer-events: all;
}

nav .mobile-section-nav li a,
nav .mobile-section-nav li ul li a,
nav ul.tp-nav-main li a,
nav ul.tp-nav-main li ul li a {
    border-left: 4px solid #fff;
    /* background-color: #fff; */
}

.dropdown a,
.dropdown-menu a,
.dropdown-submenu a {
    text-decoration: none !important;
}

.list-group-item-action {
    width: 100%;
    color: #495057;
    text-align: inherit;
}
nav .mobile-section-nav li a:focus,
nav .mobile-section-nav li ul li a:focus,
nav ul.tp-nav-main li a:focus,
nav ul.tp-nav-main li ul li a:focus {
    z-index: 1070;
}

.nav-lvl1 a.active {
    border-left: 4px solid #84bc49;
}
/* .left-nav > div > div:not(.h4) > a.active, .left-nav > div > div:not(.h4) > a.active:not([href]):not([tabindex]) {
    border-left: 4px solid #84bc49;
} */

#svg-down.show {
    transform: rotate(180deg);
}

.h4 {
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
}
</style>
